const BONUSES_PREFIX = '@@bonuses/';

export const BONUSES_ACTION_TYPES = {
    FETCH_REQUEST: `${BONUSES_PREFIX}FETCH_REQUEST`,
    FETCH_SUCCESS: `${BONUSES_PREFIX}FETCH_SUCCESS`,
    FETCH_FAILURE: `${BONUSES_PREFIX}FETCH_FAILURE`,
    APPLY_REQUEST: `${BONUSES_PREFIX}APPLY_REQUEST`,
    APPLY_SUCCESS: `${BONUSES_PREFIX}APPLY_SUCCESS`,
    APPLY_FAILURE: `${BONUSES_PREFIX}APPLY_FAILURE`,
    CLEAR_POINTS: `${BONUSES_PREFIX}CLEAR_POINTS`,
};
